var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRekognition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.687 30.298l-6.457-6.287a10.706 10.706 0 01-2.225 2.227l6.3 6.45c.31.31.682.338.928.304.389-.05.792-.267 1.137-.612.595-.596.895-1.503.317-2.082zm-15.019-2.95c5.332 0 9.671-4.34 9.671-9.676 0-5.334-4.339-9.675-9.671-9.675-5.333 0-9.671 4.34-9.671 9.675 0 5.336 4.338 9.676 9.671 9.676zm15.407 5.737c-.5.501-1.11.82-1.716.896a2.217 2.217 0 01-.29.019 2.05 2.05 0 01-1.473-.61l-6.433-6.588a10.583 10.583 0 01-5.495 1.543C11.786 28.345 7 23.557 7 17.672S11.786 7 17.668 7s10.668 4.787 10.668 10.672a10.6 10.6 0 01-1.541 5.497l6.592 6.419c.924.924.79 2.393-.312 3.497zm-8.622-15.413c0-3.807-2.98-6.788-6.785-6.788s-6.785 2.981-6.785 6.788c0 3.807 2.98 6.789 6.785 6.789s6.785-2.982 6.785-6.789zm.997 0c0 4.366-3.418 7.786-7.782 7.786s-7.782-3.42-7.782-7.786 3.418-7.786 7.782-7.786 7.782 3.42 7.782 7.786zM15.22 19.614h-.997v1.995h1.994v-.998h-.997v-.997zm-.997-3.99h.997v-.997h.997v-.997h-1.994v1.995zm4.984-.997h.997v.998h.997V13.63h-1.994v.997zm.997 4.987h.997v1.995h-1.994v-.998h.997v-.997z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRekognition);
export default __webpack_public_path__ + "static/media/Rekognition.d5fe4f90d8a4c5d5b9cf9adb944fe9a8.svg";
export { ForwardRef as ReactComponent };